import React from "react";
import Link from "@amzn/awsui-components-react/polaris/link";
import { useOnFollowHandler } from "./hooks";
import { useTranslation } from "react-i18next";
import { IInfoProps } from "./interfaces";

const Info: React.FC<IInfoProps> = (props: IInfoProps) => {
  const { t } = useTranslation();
  const label = t("features.info.label");
  const onFollowHandler = useOnFollowHandler(props);

  return (
    <Link variant="info" onFollow={onFollowHandler} data-testid="info">
      {label}
    </Link>
  );
};

export default Info;
